import { c as _c } from "react/compiler-runtime";
import { cn } from '@algoacademy/design-system/shared/cn';
import { FilterBadges } from '@algoacademy/design-system/web/navigation/FilterBadges';
import type { Dispatch, SetStateAction } from 'react';
export enum MENTORING_TABS {
  GROUP = 'Mentoring podstawowy',
  INDIVIDUAL = 'Mentoring rozszerzony',
  PROJECT = 'Mentoring projektowy',
}
export const MENTORING_TYPE_FILTER_OPTIONS = {
  GROUP: MENTORING_TABS.GROUP,
  INDIVIDUAL: MENTORING_TABS.INDIVIDUAL,
  PROJECT: MENTORING_TABS.PROJECT
} as const satisfies Record<string, MENTORING_TABS>;
type MentoringTabsProps = {
  tabs: MENTORING_TABS[];
  activeTab: MENTORING_TABS;
  setActiveTab: Dispatch<SetStateAction<MENTORING_TABS>>;
  className?: string;
};
export function MentoringTabs(t0) {
  const $ = _c(11);
  const {
    tabs,
    activeTab,
    setActiveTab,
    className
  } = t0;
  let t1;
  if ($[0] !== tabs) {
    t1 = Object.fromEntries(tabs.map(_temp));
    $[0] = tabs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1 as Record<string, MENTORING_TABS>;
  let t2;
  if ($[2] !== className) {
    t2 = cn("flex justify-center", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeTab || $[5] !== options || $[6] !== setActiveTab) {
    t3 = <FilterBadges options={options} activeFilter={activeTab} onFilterChange={setActiveTab} className="text-base" />;
    $[4] = activeTab;
    $[5] = options;
    $[6] = setActiveTab;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(tab) {
  return [tab, tab];
}